/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressesDto } from '../../models/addresses-dto';

export interface ApiOrderOrdersStoredaddressesGet$Plain$Params {
}

export function apiOrderOrdersStoredaddressesGet$Plain(http: HttpClient, rootUrl: string, params?: ApiOrderOrdersStoredaddressesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddressesDto>> {
  const rb = new RequestBuilder(rootUrl, apiOrderOrdersStoredaddressesGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddressesDto>;
    })
  );
}

apiOrderOrdersStoredaddressesGet$Plain.PATH = '/api/order/orders/storedaddresses';
